<div class="modal-header">
    <h5 class="modal-title">Add Unregistered Vendor</h5>
    <a class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
        <span class="fa fa-times-circle fa-2x" aria-hidden="true"></span>
    </a>
  </div>
  <div class="modal-body">
    <form [formGroup]="unregisteredVendorForm">
      <div class="form-group">
        <label for="name">Vendor Name</label>
        <input type="text" id="name" class="form-control" formControlName="name" placeholder="Enter vendor name" />
      </div>
      <div class="form-group">
        <label for="email">Vendor Email</label>
        <input type="email" id="email" class="form-control" formControlName="email" placeholder="Enter vendor email" />
      </div>
      <div class="form-group">
        <label for="contact_number">Contact Number</label>
        <input type="text" id="contact_number" class="form-control" formControlName="contact_number" placeholder="Enter contact number" />
      </div>
      <div class="form-group">
        <label for="country">Country</label>
        <input type="text" id="country" class="form-control" formControlName="country" placeholder="Enter country" />
      </div>
      <div class="form-group">
        <label for="city">City</label>
        <input type="text" id="city" class="form-control" formControlName="city" placeholder="Enter city" />
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="submitVendor()">Submit</button>
  </div>
  